import type { Container } from 'pixi.js';
import cloneDeep from 'lodash/cloneDeep';
import type { IObservableValue } from '../../mainMenu/types';
import type { AppStateController } from './AppStateController';
import type { AppState, StateFromAppStateKeys } from './AppState';

export class ObservableValue<K extends keyof AppState = keyof AppState>
  implements IObservableValue<StateFromAppStateKeys<K>>
{
  constructor(
    private readonly state: AppStateController,
    private readonly fields: K[],
  ) {}

  public getValue(): StateFromAppStateKeys<K> {
    return cloneDeep(
      Object.fromEntries(this.fields.map((key) => [key, this.state.getData()[key]])) as StateFromAppStateKeys<K>,
    );
  }

  public updateValue(newValue: Partial<StateFromAppStateKeys<K>>): void {
    void this.state.setData(newValue);
  }

  public addChangeHandler(
    lifeCycleObject: Container,
    callback: (newValue: StateFromAppStateKeys<K>) => void,
    skipInitCall = false,
  ): void {
    this.state.subscriptions.onChange(
      this.fields,
      () => {
        callback(this.getValue());
      },
      lifeCycleObject,
    );
    if (!skipInitCall) callback(this.getValue());

    lifeCycleObject.once('destroyed', () => {
      this.state.subscriptions.removeAllSubscriptions(lifeCycleObject);
    });
  }
}
